export var CommunicationRequestType = /*#__PURE__*/function (CommunicationRequestType) {
  CommunicationRequestType["Informational"] = "Informational";
  CommunicationRequestType["Approval"] = "Approval";
  CommunicationRequestType["Template"] = "Template";
  CommunicationRequestType["Send"] = "Send";
  CommunicationRequestType["Outlook"] = "Outlook";
  return CommunicationRequestType;
}({});
